import NetworkService from './networkService';

export default NetworkService;
